import React from 'react';
import { useDroppable } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Lead, EtapaLead, ETAPA_LABELS, ETAPA_COLORS } from '@/types/sales';
import LeadCard from './LeadCard';

interface KanbanColumnProps {
  etapa: EtapaLead;
  leads: Lead[];
  onLeadClick: (lead: Lead) => void;
  searchTerm?: string;
}

const KanbanColumn: React.FC<KanbanColumnProps> = ({ etapa, leads, onLeadClick, searchTerm = '' }) => {
  const { setNodeRef, isOver } = useDroppable({
    id: etapa
  });

  // Filtrar leads pela busca
  const filteredLeads = leads.filter(lead => {
    if (!searchTerm) return true;
    const term = searchTerm.toLowerCase();
    return (
      lead.nome_empresa.toLowerCase().includes(term) ||
      lead.cnpj.includes(term) ||
      lead.email.toLowerCase().includes(term)
    );
  });

  return (
    <div
      ref={setNodeRef}
      className={`flex-shrink-0 w-80 transition-all ${isOver ? 'opacity-75' : ''}`}
    >
      <Card className={`h-full border-t-4`} style={{ borderTopColor: ETAPA_COLORS[etapa] }}>
        <CardHeader className="pb-3">
          <div className="flex items-center justify-between">
            <CardTitle className="text-base font-semibold">
              {ETAPA_LABELS[etapa]}
            </CardTitle>
            <Badge
              variant="secondary"
              className="rounded-full"
              style={{
                backgroundColor: `${ETAPA_COLORS[etapa]}20`,
                color: ETAPA_COLORS[etapa]
              }}
            >
              {filteredLeads.length}
            </Badge>
          </div>
        </CardHeader>
        
        <CardContent className="pt-0">
          <SortableContext items={filteredLeads.map(l => l.id)} strategy={verticalListSortingStrategy}>
            <div className="space-y-3 max-h-[calc(100vh-300px)] overflow-y-auto pr-2">
              {filteredLeads.map(lead => (
                <LeadCard
                  key={lead.id}
                  lead={lead}
                  onClick={() => onLeadClick(lead)}
                />
              ))}
              
              {filteredLeads.length === 0 && (
                <div className="text-center text-sm text-muted-foreground py-8">
                  {searchTerm ? 'Nenhum lead encontrado' : 'Nenhum lead nesta etapa'}
                </div>
              )}
            </div>
          </SortableContext>
        </CardContent>
      </Card>
    </div>
  );
};

export default KanbanColumn;


